const Cell = require('../BaseCell');
const _ = require('underscore');
const CC = require('CC');

export const ABBREVIATIONS = {
    TINY: 'tiny',
    WORD: 'standard',
    NONE: 'none'
};

export const PRECISION_MODES = {
    HIGH: true,
    LOW: false /* eg. show < 1K */
};

/**
 * Renders the cell as stat
 * @param {Object} options
 * @returns column definition
 */
export const StatCell = function(options) {
    const defaultOptions = {
        className: 'dt-body-right text-right',
        abbreviation: ABBREVIATIONS.NONE,
        precision: PRECISION_MODES.HIGH,

        /**
         * Format the value for display
         * @param {Number} value
         * @returns
         */
        formatValue: function(value) {
            return CC.converters.formatStats(value, {
                abbreviationType: this.abbreviation,
                precision: this.precision
            });
        },

        /**
         * Format the value for export
         * @param {Number} value
         * @returns
         */
        formatExportValue: function(value) {
            return CC.converters.formatStats(value, {
                abbreviationType: ABBREVIATIONS.NONE,
                precision: PRECISION_MODES.HIGH
            });
        },
        onDisplay: function(data, type, row, meta, translatedValue) {
            if (Number.isNaN(parseInt(translatedValue, 10))) {
                return /*template*/ `<span class="inactive">${translatedValue}</span>`;
            } else {
                return this.formatValue(translatedValue);
            }
        },
        onExport: function(data, type, row, meta, translatedValue, model) {
            if (Number.isNaN(parseInt(translatedValue, 10))) {
                return translatedValue || '';
            } else {
                return this.formatExportValue(translatedValue);
            }
        },
        /**
         * Handle numbers that come in as strings...
         * @param {(String|Number)} value The number value
         * @returns Number
         */
        convertNumber: function(value) {
            return parseInt(value, 10);
        }
    };
    return {
        CellClass: Cell,
        options: _.extend({}, defaultOptions, options)
    };
};
